import axios from 'axios'
import { getDefaultStrDate, clone, colName, getWorkingDays, deleteKeyNullValues } from '@/util/libUtil.js'
import * as objectivesTemplate from '@/util/objectivesTemplate.json'


const state = () => ({
	comercialesInfo: [],
	comerciales: [],
	selectedComerciales: [],
	files: [],

	isLoadingInfo: false,
	isLoadingSingleView: false,
	isOpenFilterDialog: false,
	isOpenDownload: false,
	isOpenModHeadersDialog: false,

	dateFilter: [],
	selectedState: 'ALTA',
	selectedTipoComercial: 'TODOS',
	currentComercial: null,
	currentComercialAttentions: [],
	singleViewDialog: false,
	attentionsTableItemCount: 0,
	paths: {
		submitXLSX: '/api/utils/read-xlsx/',
		getInfoPath: '/api/comerciales/gerencia-filters/',

		'atencionCount': '/api/comerciales/gerencia-filters-atencion-count',
		'agendadoCount': '/api/comerciales/gerencia-filters-agendado-count',
		'gestionCount': '/api/comerciales/gerencia-filters-gestion-count',
		'nointeresadoCount': '/api/comerciales/gerencia-filters-nointeresado-count',
		'vendidoCount': '/api/comerciales/gerencia-filters-vendido-count',
		'ofertaCount': '/api/comerciales/gerencia-filters-oferta-count',
		'clienteCount': '/api/comerciales/gerencia-filters-cliente-count',
		'paqueteCount': '/api/comerciales/gerencia-filters-paquete-count',

		getXLSX: '/api/comerciales/gerencia/download-xlsx-gerencia/',
		getAttentionsXLSX: '/api/atenciones/gerencia/download-xlsx-atenciones-comercial',
		comercialesPath: '/api/comerciales/',
		singleCommercialAtencionesPath: '/api/atenciones/entradas/',
	}
})

const mutations = {
	comercialesInfo: (state, val) => {
		state.comercialesInfo = clone(val)
	},
	isLoadingInfo: (state, val) => {
		state.isLoadingInfo = val
	},
	isOpenFilterDialog: (state, val) => {
		state.isOpenFilterDialog = val
	},
	isOpenDownload: (state, val) => {
		state.isOpenDownload = val
	},
	dateFilter: (state, val) => {
		state.dateFilter = clone(val)
	},
	selectedComerciales: (state, val) => {
		state.selectedComerciales = clone(val)
	},
	selectedState: (state, val) => {
		state.selectedState = val
	},
	selectedTipoComercial: (state, val) => {
		state.selectedTipoComercial = val
	},
	comerciales: (state, val) => {
		state.comerciales = clone(val)
	},
	currentComercial: (state, val) => {
		state.currentComercial = clone(val)
	},
	singleViewDialog: (state, val) => {
		state.singleViewDialog = val
	},
	isLoadingSingleView: (state, val) => {
		state.isLoadingSingleView = val
	},
	currentComercialAttentions: (state, val) => {
		state.currentComercialAttentions = clone(val)
	},
	files: (state, val) => {
		state.files = clone(val)
	},
	attentionsTableItemCount: (state, val) => {
		state.attentionsTableItemCount = val
	},
	isOpenModHeadersDialog: (state, val) => {
		state.isOpenModHeadersDialog = val
	}
}


const actions = {
	async download_template_from_json({ state, dispatch, rootState }, jsonTemplate) {
		let template = clone(jsonTemplate)

		dispatch('util/download_XLSX_from_JSON', {
			jsonFile: template,
			jsonName: `BDClientes_${getDefaultStrDate(new Date())}`,
		}, { root: true })
	},
	async download_objectives_template({ state, dispatch, rootState }) {
		let template = clone(objectivesTemplate.default)
		await dispatch('fetchComerciales')
		await dispatch('areaPersonal/calculadora/fetchTipoObjetivo', {}, { root: true })

		let lastLetterIndex = null
		rootState.areaPersonal.calculadora.tipo_objetivo.forEach((objetivo, index) => {
			const gapToWrite = 3
			let letterA = colName(index + gapToWrite)
			let letterB = colName(index + gapToWrite)

			template['xlsx_info']['Comercial Tienda']['content'][0].text.unshift("") // LLAVE
			template['xlsx_info']['Comercial Tienda']['content'][1].text.unshift("") // PESO
			template['xlsx_info']['Comercial Tienda']['content'][2].text.splice(index + 2, 0, objetivo.id) // OBJETIVO

			template['xlsx_info']['Comercial DBL']['content'][0].text.unshift("") // LLAVE
			template['xlsx_info']['Comercial DBL']['content'][1].text.unshift("") // PESO
			template['xlsx_info']['Comercial DBL']['content'][2].text.splice(index + 2, 0, objetivo.id) // OBJETIVO

			template['xlsx_info']['Comercial Colaborador']['content'][0].text.unshift("") // LLAVE
			template['xlsx_info']['Comercial Colaborador']['content'][1].text.unshift("") // PESO
			template['xlsx_info']['Comercial Colaborador']['content'][2].text.splice(index + 2, 0, objetivo.id) // OBJETIVO

			template['xlsx_info']['Comercial Recomendador']['content'][0].text.unshift("") // LLAVE
			template['xlsx_info']['Comercial Recomendador']['content'][1].text.unshift("") // PESO
			template['xlsx_info']['Comercial Recomendador']['content'][2].text.splice(index + 2, 0, objetivo.id) // OBJETIVO

			template['xlsx_info']['Comercial sin clasificar']['content'][0].text.unshift("") // LLAVE
			template['xlsx_info']['Comercial sin clasificar']['content'][1].text.unshift("") // PESO
			template['xlsx_info']['Comercial sin clasificar']['content'][2].text.splice(index + 2, 0, objetivo.id) // OBJETIVO

			template['xlsx_info']['Comercial Tienda']['content'][0].position = "C1-" + letterB.toUpperCase() + "1"
			template['xlsx_info']['Comercial Tienda']['content'][1].position = "C2-" + letterB.toUpperCase() + "2"
			template['xlsx_info']['Comercial Tienda']['content'][2].position = "A3-" + letterA.toUpperCase() + "3"
			template['xlsx_info']['Comercial DBL']['content'][0].position = "C1-" + letterB.toUpperCase() + "1"
			template['xlsx_info']['Comercial DBL']['content'][1].position = "C2-" + letterB.toUpperCase() + "2"
			template['xlsx_info']['Comercial DBL']['content'][2].position = "A3-" + letterA.toUpperCase() + "3"
			template['xlsx_info']['Comercial Colaborador']['content'][0].position = "C1-" + letterB.toUpperCase() + "1"
			template['xlsx_info']['Comercial Colaborador']['content'][1].position = "C2-" + letterB.toUpperCase() + "2"
			template['xlsx_info']['Comercial Colaborador']['content'][2].position = "A3-" + letterA.toUpperCase() + "3"
			template['xlsx_info']['Comercial Recomendador']['content'][0].position = "C1-" + letterB.toUpperCase() + "1"
			template['xlsx_info']['Comercial Recomendador']['content'][1].position = "C2-" + letterB.toUpperCase() + "2"
			template['xlsx_info']['Comercial Recomendador']['content'][2].position = "A3-" + letterA.toUpperCase() + "3"
			template['xlsx_info']['Comercial sin clasificar']['content'][0].position = "C1-" + letterB.toUpperCase() + "1"
			template['xlsx_info']['Comercial sin clasificar']['content'][1].position = "C2-" + letterB.toUpperCase() + "2"
			template['xlsx_info']['Comercial sin clasificar']['content'][2].position = "A3-" + letterA.toUpperCase() + "3"

			lastLetterIndex = index
		})

		const CORRESPONDENCE = {
			"TIENDA": "Comercial Tienda",
			"DBL": "Comercial DBL",
			"COLABORADOR": "Comercial Colaborador",
			"RECOMENDADOR": "Comercial Recomendador",
			"SIN DEFINIR": "Comercial sin clasificar",
		}

		let counters = {
			"TIENDA": 0,
			"DBL": 0,
			"COLABORADOR": 0,
			"RECOMENDADOR": 0,
			"SIN DEFINIR": 0,
		}
		const headerJMP = 4
		state.comerciales.filter(({ estado }) => (estado == 'ALTA')).forEach((comercial, index) => {
			let comercialType = comercial.tipo_comercial ? comercial.tipo_comercial : "SIN DEFINIR"
			let commercial_pos = 'B' + (counters[comercialType] + headerJMP)
			let holidays_pos = 'A' + (counters[comercialType] + headerJMP)
			counters[comercialType]++
			let holidays_obj = {
				'position': holidays_pos,
				'text': [
					"0"
				],
				'format': [{ 'bold': 'True', 'bg_color': 'd1b0e6' }],
			}

			let commercial_obj = {
				'position': commercial_pos,
				'text': [
					comercial.username,
				],
				'format': [{ 'bold': 'True', 'bg_color': 'f3dbf1' }],
			}


			if (comercial.tipo_comercial == "TIENDA") {
				template['xlsx_info']['Comercial Tienda']['content'].push(holidays_obj)
				template['xlsx_info']['Comercial Tienda']['content'].push(commercial_obj)
			} else if (comercial.tipo_comercial == "DBL") {
				template['xlsx_info']['Comercial DBL']['content'].push(holidays_obj)
				template['xlsx_info']['Comercial DBL']['content'].push(commercial_obj)
			} else if (comercial.tipo_comercial == 'COLABORADOR') {
				template['xlsx_info']['Comercial Colaborador']['content'].push(holidays_obj)
				template['xlsx_info']['Comercial Colaborador']['content'].push(commercial_obj)
			} else if (comercial.tipo_comercial == 'RECOMENDADOR') {
				template['xlsx_info']['Comercial Recomendador']['content'].push(holidays_obj)
				template['xlsx_info']['Comercial Recomendador']['content'].push(commercial_obj)
			} else {
				template['xlsx_info']['Comercial sin clasificar']['content'].push(holidays_obj)
				template['xlsx_info']['Comercial sin clasificar']['content'].push(commercial_obj)
			}

		})

		const objectivesJMP = 5
		let workDays = {
			"position": `"${colName(lastLetterIndex + objectivesJMP)}1-${colName(lastLetterIndex + objectivesJMP + 1)}1"`,
			"text": [
				"DÍAS LABORABLES",
				getWorkingDays(new Date())
			],
			"format": [{ "bold": "True", "bg_color": "FF838F" }]
		}

		template['xlsx_info']['Comercial Tienda']['content'].push(workDays)
		template['xlsx_info']['Comercial DBL']['content'].push(workDays)
		template['xlsx_info']['Comercial Colaborador']['content'].push(workDays)
		template['xlsx_info']['Comercial Recomendador']['content'].push(workDays)
		template['xlsx_info']['Comercial sin clasificar']['content'].push(workDays)

		// If counter is 0 then delete de key of object
		Object.keys(counters).forEach(key => {
			if (counters[key] == 0) {
				delete template['xlsx_info'][CORRESPONDENCE[key]]
			}
		})


		dispatch('util/download_XLSX_from_JSON', {
			jsonFile: template,
			jsonName: `Objetivos_${getDefaultStrDate(new Date())}`,
		}, { root: true })
	},
	importFiles({ state, dispatch }, params) {
		dispatch('util/exportDB', {
			params: params,
			files: state.files,
			path: state.paths.submitXLSX,
			title: `Reporte_${getDefaultStrDate(new Date())}`,
		}, { root: true })
	},
	exportDB({ state, dispatch }) {
		dispatch('util/exportDB', {
			path: state.paths.getXLSX,
			params: { fechas: state.dateFilter, estado: state.selectedState, tipo_comercial: state.selectedTipoComercial },
			title: `ReporteGerenciaComerciales_${getDefaultStrDate(new Date())}`,
		}, { root: true })
	},
	exportAttentions({ state, dispatch }) {
		if (state.dateFilter.length == 0) {
			let defaultDate = [];
			defaultDate.push(
				new Date(new Date().getFullYear(), new Date().getMonth(), 2)
					.toISOString()
					.substr(0, 10)
			);
			defaultDate.push(
				new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)
					.toISOString()
					.substr(0, 10)
			);
			state.dateFilter = defaultDate
		}

		dispatch('util/exportDB', {
			path: state.paths.getAttentionsXLSX,
			params: { updated_on: state.dateFilter, comercial: state.currentComercial.id },
			title: `Reporte_${state.currentComercial.nombre.replaceAll(' ', '_')}_${getDefaultStrDate(new Date())}`,
		}, { root: true })
	},
	async fetchComerciales({ commit, getters, state }) {
		try {
			let resp = await axios.get(getters.getEndpointFromPath(state.paths.comercialesPath))
			commit('comerciales', resp.data)
		}
		catch {
			dispatch('util/showStatusSnackBar', {
				statusType: 'error',
				message: 'No se han cargado las opciones de comerciales'
			}, { root: true })
		}
	},
	async fetchAtenciones({ commit, getters, state, dispatch }, params) {
		commit('isLoadingSingleView', true)

		if (state.dateFilter.length == 0) {
			let defaultDate = [];
			defaultDate.push(
				new Date(new Date().getFullYear(), new Date().getMonth(), 2)
					.toISOString()
					.substr(0, 10)
			);
			defaultDate.push(
				new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)
					.toISOString()
					.substr(0, 10)
			);
			state.dateFilter = defaultDate
		}
		let resp = await axios.get(getters.getEndpointFromPath(state.paths.singleCommercialAtencionesPath), { params })
		if (state.dateFilter.length == 0)
			defaultDate = null

		commit('isLoadingSingleView', false)
		commit('attentionsTableItemCount', resp.data.count)
		commit('currentComercialAttentions', resp.data.results)
	},
	async getComercialesData({ dispatch, getters, state, commit }, { newParams = null }) {
		try {
			commit('isLoadingInfo', true)

			let params = null
			if (newParams) {
				const realDate = new Date(newParams.newDate);
				const firstDay = new Date(realDate.getFullYear(), realDate.getMonth(), 1);
				const lastDay = new Date(realDate.getFullYear(), realDate.getMonth() + 1, 0);
				// get last day of month
				params = {
					fechas: [`${newParams.newDate}-${firstDay.getDate()}`, `${newParams.newDate}-${lastDay.getDate()}`],
					estado: newParams.estado,
					tipo_comercial: newParams.tipoComercial
				}
			} else {
				params = {
					fechas: state.dateFilter,
					estado: state.selectedState,
					tipo_comercial: state.selectedTipoComercial,
				}
			}

			let gerenciaPaths = [
				'atencionCount',
				'agendadoCount',
				'gestionCount',
				'nointeresadoCount',
				'vendidoCount',
				'ofertaCount',
				'clienteCount',
				'paqueteCount'
			]

			const promises = gerenciaPaths.map((path) => {
				return axios.get(getters.getEndpointFromPath(state.paths[path]), {
					params: deleteKeyNullValues(params)
				})

			})

			Promise.all([...promises]).then(function (values) {
				let auxDict = {}
				for (const [path, response] of Object.entries(values)) {
					for (const [key, value] of Object.entries(response.data)) {
						if (!value['id'] in auxDict)
							auxDict[value['id']] = {}

						auxDict[value['id']] = { ...auxDict[value['id']], ...value }
					}
				}

				let resp = Object.values(auxDict)

				let comerciales = [
					...resp.filter(({ nombre }) => !nombre.includes('invitado')),
					...resp.filter(
						({ nombre }) => nombre.includes('invitado')).sort((a, b) =>
							(parseInt(a.nombre.replace(/.*[a-z]/, '')) > parseInt(b.nombre.replace(/.*[a-z]/, ''))) ? 1 : -1)
				]
				commit('comercialesInfo', comerciales)
				commit('isLoadingInfo', false)

				dispatch('util/showStatusSnackBar', {
					statusType: 'success',
					message: 'Información Recopilada'
				}, { root: true })

				return comerciales
			});
		}
		catch {
			dispatch('util/showStatusSnackBar', {
				statusType: 'error',
				message: 'No se pudo cargar el contenido'
			}, { root: true })
		}
	},

}

const getters = {
	getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
		rootState.general.host + endpoint
	)
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}